import BaseListagem from "components/BaseListagem";
import Usuario from "model/administracao/cadastro/Usuario";
import Veiculo from "model/gestao/frotas/Veiculo";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import RotaService from "service/transportes/RotaService";
import { converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";

const rotaService = new RotaService();

export default function RotaListagem() {

    const [queryParameters] = useSearchParams();

    const [motoristas, setMotoristas] = useState<Usuario[]>([]);
    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);

    const [titulo, setTitulo] = useState<string>('Rotas');

    useEffect(() => {
        rotaService.motoristas().then((data) => {
            setMotoristas(data);
        }).catch(err => {
            console.log(err);
        });

        rotaService.veiculos().then((data) => {
            setVeiculos(data);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataPrevista: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        motorista: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        veiculo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={rotaService} urlService="/rota" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="rota" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="status" header="Status" filter showFilterOperator={false} showAddButton={false} body={(rowData)=> rotaService.getStatusLabel(rowData.status)} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options)=>statusFilterTemplate(options, rotaService.getListStatus())} />
            <Column body={(rowData)=>converterDataHora(rowData.dataPrevistaInicio)} header="Data Início" filter showFilterOperator={false} showAddButton={false} showFilterMatchModes={false} filterPlaceholder="Escreva o filtro" filterField="dataPrevista"
                filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate} filterElement={dateRangeFilterTemplate} />
            <Column field="motorista.nome" header="Motorista" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="motorista"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options)=>dropdownFilterTemplate(options, motoristas)} />
            <Column field="veiculo.modelo" header="Veículo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="veiculo"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options)=>dropdownFilterTemplate(options, veiculos, "modelo")} />
        </BaseListagem>
    )
}